import React, { useRef, useState, useEffect } from "react";
import { Menu } from "primereact/menu";
import { TieredMenu } from "primereact/tieredmenu";
import { Button } from "primereact/button";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Reports from "../pages/Reports";
import Dashboard from '../pages/Dashboard';
import Masters from "../pages/Masters";


const Main = () => {
  const menu = useRef(null);
  const name = sessionStorage.getItem("roleName");

  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);
  
  const clearSession = () => {
    sessionStorage.clear();
    // localStorage.removeItem('sessionId');
    navigate("/");
  };

  const displayContent = () => {
    return (
      <Routes>
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/geoMaster" element={<Masters />} />
        <Route exact path="/reports" element={<Reports />} />
      </Routes>
    );
  };

  const items1 = [
    {
      label: "Log out",
      icon: "pi pi-sign-out",
      command: () => {
        clearSession();
      },
      // style: { fontFamily: '"Poppins", sans-serif' }
    },
  ];

  const SuperItems = [
    {
      label: (
        <p className={`m-0 pt-1 ${activeTab === "/main/dashboard" ? "active-text" : ""}`}>
          Dashboard
        </p>
      ),
      icon: activeTab === "/main/dashboard" ? (
        <i className="pi pi-objects-column" style={{ fontSize: "22px", color: "#4285F4", paddingRight: "10px" }} />
      ) : (
        <i className="pi pi-objects-column" style={{ fontSize: "24px", paddingRight: "10px" }} />
      ),
      className: activeTab === "/main/dashboard" ? "active-tab" : "",
      command: () => {
        setActiveTab("/main/dashboard");
        navigate("/main/dashboard");
      },
    },
    {
      label: (
        <p className={`m-0 ${activeTab === "/main/geoMaster" ? "active-text" : ""}`}>
         Master Management
        </p>
      ),
      icon: activeTab === "/main/geoMaster" ? (
        <i className="pi pi-map-marker" style={{ fontSize: "22px", color: "#4285F4", paddingRight: "10px" }} />

      ) : (
        <i className="pi pi-map-marker" style={{ fontSize: "24px", paddingRight: "10px" }} />
      ),
      className: activeTab === "/main/geoMaster" ? "active-tab" : "",
      command: () => {
        setActiveTab("/main/geoMaster");
        navigate("/main/geoMaster");
      },
    },
    {
      label: (
        <p className={`m-0 ${activeTab === "/main/reports" ? "active-text" : ""}`}>
          Raw Data Report
        </p>
      ),
      icon: activeTab === "/main/reports" ? (
        <i className="pi pi-database" style={{ fontSize: "22px", color: "#4285F4", paddingRight: "10px" }} />
      ) : (
        <i className="pi pi-database" style={{ fontSize: "24px", paddingRight: "10px" }} />
      ),
      className: activeTab === "/main/reports" ? "active-tab" : "",
      command: () => {
        setActiveTab("/main/reports");
        navigate("/main/reports");
      },
    },
  ];
  return (
    <>
      <div className="sidebar">
        <div className="flex justify-content-center mt-5">
          <img src="/mhgpalogo.png" alt="logo" style={{ width: "180px" }} />
        </div>
        <div className="menu-container">
          <Menu model={SuperItems} className="sidebarMenu mt-7 pl-4" />
        </div>
        <div
          className="sidebartieredmenu-container"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
          }}
        >
          <TieredMenu model={items1} popup ref={menu} />
          <Button
            className="sidebartieredmenu"
            onClick={(e) => menu.current.toggle(e)}
          >
            <i className="pi pi-user" />
            <span className="menuFont">{name}</span>
            <i className="pi pi-chevron-up" />
          </Button>
        </div>
      </div>
      <div className="cardStyle">
        <div>{displayContent()}</div>
      </div>
    </>
  );
};
export default Main;
